import { actionTree, getterTree, mutationTree } from 'typed-vuex'
import { cloneDeep, eq, isEqual } from 'lodash-es'
import { ORDER_ASC, SORT_DATE, applySorting } from '@/lib/utils/mailboxSortAndFilter'
import { shallowObjectCopy } from '~/lib/utils/utils'
import { applyMailboxFilters } from '~/lib/utils/filters'

const MAILBOX_PREFIX = 'mailbox'

const defaultFilters = {
  mailbox: {
    query: ''
  }
}

const defaultSortingParam = {
  mailbox: {
    order: ORDER_ASC,
    sortBy: SORT_DATE
  }
}

function setListState(state, payload) {
  // @ts-ignore
  // eslint-disable-next-line prefer-const
  let { nameSpace, value } = payload

  nameSpace = nameSpace.split('/')

  const lastItem = nameSpace[nameSpace.length - 1]

  nameSpace.splice(nameSpace.length - 1, 1)
  // @ts-ignore
  // eslint-disable-next-line no-return-assign
  nameSpace.forEach(path => state = state[path])

  state[lastItem] = value
}

export const state = () => ({
  mailbox: {
    sort: {
      ...shallowObjectCopy(defaultSortingParam.mailbox)
    },
    filter: {
      ...shallowObjectCopy(defaultFilters.mailbox)
    },
    result: null,
    sorted: false,
    filtered: false
  }
})

export const getters = getterTree(
  state,
  {
    [`${MAILBOX_PREFIX}/set`](state, getters, rootState) {
      return rootState[MAILBOX_PREFIX][rootState[MAILBOX_PREFIX].mailState]
    }
  }
)

export const mutations = mutationTree(
  state, {
    setListState
  }
)

export const actions = actionTree(
  { state, getters, mutations }, {
    setFilterParam({ state, commit, getters }, payload) {
      const { nameSpace, filterBy, parameter } = payload
      commit('setListState', { nameSpace: `${nameSpace}/filter/${filterBy}`, value: parameter })
    },
    mutateList({ state, commit, getters }, nameSpace) {
      const source = getters[`${nameSpace}/set`]
      const sortBy = state[nameSpace].sort.sortBy === null ? SORT_DATE : state[nameSpace].sort.sortBy
      const order = state[nameSpace].sort.order
      const result = applySorting(applyMailboxFilters(cloneDeep(source), state[nameSpace].filter), sortBy, order)

      commit('setListState', { nameSpace: `${nameSpace}/result`, value: result })
    },
    applyFilter({ state, commit, getters, dispatch }, nameSpace) {
      const equal = isEqual(defaultFilters[nameSpace], state[nameSpace].filter)
      dispatch('mutateList', nameSpace)
      commit('setListState', { nameSpace: `${nameSpace}/filtered`, value: !equal })
    },
    resetFilter({ state, commit, getters, dispatch }, nameSpace) {
      const defaultValues = shallowObjectCopy(defaultFilters[nameSpace])
      commit('setListState', { nameSpace: `${nameSpace}/filter`, value: defaultValues })
      dispatch('mutateList', nameSpace)
      commit('setListState', { nameSpace: `${nameSpace}/result`, value: null })
      commit('setListState', { nameSpace: `${nameSpace}/filtered`, value: false })
    },
    sortList({ state, commit, getters, dispatch }, playload) {
      const { nameSpace, sortBy, order } = playload
      commit('setListState', { nameSpace: `${nameSpace}/sort/sortBy`, value: sortBy })
      commit('setListState', { nameSpace: `${nameSpace}/sort/order`, value: order })
      dispatch('mutateList', nameSpace)
      commit('setListState', { nameSpace: `${nameSpace}/sorted`, value: true })
    },
    resetSort({ commit, dispatch }, nameSpace) {
      const defaultValues = shallowObjectCopy(defaultSortingParam[nameSpace])
      commit('setListState', { nameSpace: `${nameSpace}/sort`, value: defaultValues })
      dispatch('mutateList', nameSpace)
      commit('setListState', { nameSpace: `${nameSpace}/result`, value: null })
      commit('setListState', { nameSpace: `${nameSpace}/sorted`, value: false })
    },
    reset({ commit, dispatch }, nameSpace) {
      const defaulSortValues = shallowObjectCopy(defaultSortingParam[nameSpace])
      const defaulFiltertValues = shallowObjectCopy(defaultFilters[nameSpace])
      commit('setListState', { nameSpace: `${nameSpace}/sort`, value: defaulSortValues })
      commit('setListState', { nameSpace: `${nameSpace}/filter`, value: defaulFiltertValues })
      dispatch('mutateList', nameSpace)
      commit('setListState', { nameSpace: `${nameSpace}/result`, value: null })
      commit('setListState', { nameSpace: `${nameSpace}/sorted`, value: false })
      commit('setListState', { nameSpace: `${nameSpace}/filtered`, value: false })
    }

  }
)
